import {TranslateService} from '@ngx-translate/core';

import {DashboardChartUtils} from './dashboard-chart.utils';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {Tornado} from '../../+postpayroll/check/key-metrics/charts/column/tornado';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {Scss} from '../../shared/utils/scss';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

export class HiredTerminationChart extends Tornado {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();
    chart.accus1 = `Terminated`;
    chart.accus2 = `Hired`;

    Object.keys(params).forEach((key: string) => {
      const terminatedElement: ChartBoxElement = params[key]
        .find((element: ChartBoxElement) => element.name === chart.accus1);
      const hiredElement: ChartBoxElement = params[key]
        .find((element: ChartBoxElement) => element.name === chart.accus2);

      chart.data.push({
        category: terminatedElement.name,
        name: key,
        value: terminatedElement.value,
        metadata: terminatedElement.link
      });

      chart.data.push({
        category: hiredElement.name,
        name: key,
        value: hiredElement.value,
        metadata: hiredElement.link
      });
    });
    chart.time = true;
    chart.type = chartBox.cardType;

    super(chart, translate, localization);

    this.legend = {
      orient: 'horizontal',
      top: 0
    };
    this.yAxis[0].data = DashboardChartUtils.formatCategories(this.yAxis[0].data, translate);
    this.yAxis[0].axisLabel = DashboardChartUtils.getAxisOptions();
    this.xAxis = [{
      axisLine: {
        show: true
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
      },
      axisLabel: {
        rotate: 45
      }
    }];
    this.grid = DashboardChartUtils.getGridOptions();
    this.animation = true;

    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);

    const hired = Scss.variable('status-hired');
    const terminated = Scss.variable('status-terminated');
    const delta = Scss.variable('hire-termination-delta');
    if (hired && terminated && delta) {
      this.color = [terminated, hired, delta];
    }
  }

  public sortCategories(array: string[]): string[] {
    return DashboardChartUtils.monthSort(array);
  }
}
